/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsightData } from '../../models/insight-data';

export interface GetAverageTelemetryDataByHouse$Params {
  facilityId: number;
  date?: string;
  groupIdx?: Array<number>;
}

export function getAverageTelemetryDataByHouse(http: HttpClient, rootUrl: string, params: GetAverageTelemetryDataByHouse$Params, context?: HttpContext): Observable<StrictHttpResponse<InsightData>> {
  const rb = new RequestBuilder(rootUrl, getAverageTelemetryDataByHouse.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('date', params.date, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InsightData>;
    })
  );
}

getAverageTelemetryDataByHouse.PATH = '/api/telemetry/averages/facilityId/{facilityId}';
